module.exports = __webpack_public_path__ + "img/p6-info.a5c1b45a.jpg";